export default __webpack_public_path__ + "static/media/Spectrophotometer.5da68ab0.svg";